export const uk = {
    "TRIGGER_LISTEN" : "Прослуховування тригерів",
    "ASSIST_EMPTY_MSG" : "Агент AI активно слухає вашу розмову та готовий автоматично допомогти, коли буде активовано.",
    "MYBOT_TRIGGET_LISTEN" : "Немає активних завдань My Bot на даний момент",
    "MYBOT_EMTPY_MSG" : "Щоб розпочати завдання у My Bot, перейдіть на вкладку пошуку та виберіть 'Запустити з введеннями агента' для потрібного завдання.",
    "PROACTIVE_MODE": "Проактивний режим",
    "SETTINGS": "Налаштування",
    "HELP_AND_SUPPORT": "Довідка та підтримка",
    "HELP": "Допомога",
    "LANGUAGE": "Мова",
    "THEME": "Тема",
    "AUTO_SCROLL_TOOLTIP":"Керує автоматичним прокручуванням вкладки «Помічник», мого бота та вмісту вкладки «Транскрипт»",
    "AUTOMATIC": "Автоматично",
    "FILE_NAME":"Ім'я файлу",
    "DARK": "Темна",
    "LIGHT": "Світла",
    "THEME_DESC": "Це використовуватиме ваш системний режим за замовчуванням",
    "DOCUMENTATION": "Документація",
    "DOC_DESC": "Ознайомтесь із докладними статтями документації.",
    "FAQ_U": "ЧаП",
    "FAQ_DESC": "Перегляньте найчастіші запитання про Agent AI.",
    "KORE_ACADEMY": "Академія Kore",
    "KORE_ACA_DESC": "Дізнайтеся більше про Agent AI, переглянувши курси академії.",
    "SEARCH": "Пошук",
    "MY_BOT": "My Bot",
    "TAB_TEXT":"Жодна вкладка не увімкнена! Будь ласка, увімкніть хоча б одну вкладку",
    "ASSIST": "Асистент",
    "TRANSCRIPT": "Транскрипція",
    "HISTORY" : "Історія",
    "STARTOVER" : "Почати спочатку",
    "TAP_SEARCH":"Торкніться для пошуку",
    "RESTART_INPUTS" : "Перезапустити з захопленими введеннями",
    "ASKCUSTOMER" : "Запитати у клієнта",
    "TELLCUSTOMER" : "Сказати клієнту",
    "WELCOME_MSG" : "Привітальне повідомлення",
    "SEND" : "Відправити",
    "SENT" : "Відправлено",
    "AWAITING" : "Очікується відповідь | Введіть, щоб продовжити",
    "OVERRIDE" : "Введіть, щоб продовжити",
    "OVERRIDE_FILE" : "Прикріпіть файл для продовження",
    "ACCEPT_RESPONSE" : "Відповідь прийнята",
    "AGENT_ENTERED" : "Агент увійшов",
    "EXPECTED_FORMAT" : "Очікуваний формат", 
    "INPUT_VALUES" : "Вхідні значення", 
    "RESTART" : "Перезапуск",
    "START_OVER" : "Почати спочатку",
    "RESTART_CAPTURE" : "Перезапустити з захопленими введеннями",
    "CANCEL" : "Скасувати",
    "INTERRUPT_DIALOG" : "ПЕРЕРВАНЕ ЗАВДАННЯ ДІАЛОГУ",
    "RUN" : "Запустити",
    "RUN_AGENT" : "Запустити з введеннями агента",
    "STEP" : "Крок",
    "DIALOG_TASK" : "Завдання діалогу",
    "FAQ" : "ЧаП",
    "SNIPPET" : "Відповіді",
    "ARTICLE" : "Веб-сторінки",
    "FILE" : "Файли",
    "SUGGESTED" : "Запропоновано",
    "ALL_DIALOG" : "Усі завдання діалогу",
    "DIALOG_TEXT" : "Діалог",
    "INTENT_IDENTIFIED" : "Вислів клієнта",
    "NOT_WHAT_LOOKING" : "Неправильна пропозиція?",
    "BOT" : "Бот", 
    "CUSTOMER" : "Клієнт",
    "YOU" : "Ви",
    "TERMINATE_CONV" : "Завершити завдання діалогу",
    "TERMINATE_CONV_DESC" : "Ви впевнені, що хочете завершити завдання діалогу? Agent AI більше не зможе надавати пропозиції.",
    "YES_TERMINATE" : "Так, завершити",
    "NO_CANCEL" : "Ні, скасувати",
    "OVERRIDE_CONTINUE" : "Продовжити у режимі переозначення",
    "SUMMARY_TEXT" : "Резюме",
    "SUBMIT" : "Надіслати",
    "INTERRUPT_OCCURED" : "Виникло переривання",
    "IDENTIFIED_INTENT" : "Визначений намір",
    "INTERRUPT_DESC" : "Запуск цього завершить поточне завдання діалогу.",
    "ACCEPT_RUN" : "Прийняти та запустити",
    "RUN_LATER" : "Запустити пізніше",
    "KNOW_MORE" : "Дізнатися більше",
    "MORE_TEXT" : "Більше",
    "LESS_TEXT" : "Менше",
    "VIEW_MORE" : "Показати більше",
    "VIEW_LESS" : "Показати менше",
    "SHOW_MORE_FAQ" : "Показати більше ЧаП",
    "SHOW_LESS_FAQ" : "Показати менше ЧаП",
    "SHOW_MORE_ARTICLE" : "Показати більше веб-сторінок",
    "SHOW_LESS_ARTICLE" : "Показати менше веб-сторінок",
    "SHOW_MORE_SNIPPET" : "Показати більше відповідей",
    "SHOW_LESS_SNIPPET" : "Показати менше відповідей",
    "SHOW_MORE_FILES" : "Показати більше файлів",
    "SHOW_LESS_FILES" : "Показати менше файлів",
    "VIEW_ALL_DIALOG" : "Переглянути всі діалоги",
    "VIEW_FEW_DIALOG" : "Переглянути декілька діалогів",
    "HELP_FULL" : "Корисно?",
    "THANKYOU" : "Дякуємо!",
    "EXPAND_MORE" : "Розгорнути / Більше",
    "CLOSE_TEXT" : "Закрити",
    "STARTED" : "Розпочато",
    "ENDED" : "Завершено",
    "VIEW_FULL_ARTICLE" : "Переглянути веб-сторінку",
    "VIEW_FULL_FILE" : "Переглянути файл",
    "COPIED" : "Скопійовано",
    "SENTI_ANALY" : "Аналіз настроїв",
    "WRONG_SUGGESTION" : "Неправильні пропозиції",
    "INCORRECT_INTENT" : "Неправильний намір",
    "ACCIDENTAL_CLICK" : "Випадковий клік",
    "TIME_TAKING" : "Займає багато часу",
    "OTHER" : "Інше",
    "PLAYBOOK_EMPTY_MSG" : "Виберіть Playbook",
    "PLAYBOOK_EMPTY_DESC" : "Agent AI не може завантажити Playbook через динамічність усіх наявних playbook'ів. Натисніть 'Виберіть Playbook', щоб отримати доступ до playbook'у",
    "STAGE" : "Етап", 
    "PROCEED_TO_CLOSE" : "Перейти до завершення",
    "RECOMENDED_PLAYBOOK" : "РЕКОМЕНДОВАНИЙ PLAYBOOK",
    "PRIMARY_SCRIPTS" : "ПЕРВИННІ СЦЕНАРІЇ",
    "DYNAMIC_SCRIPTS" : "ДИНАМІЧНІ СЦЕНАРІЇ",
    "RESUME" : "Відновити",
    "ENABLE_CLOSE" : "Натисніть кнопку 'перейти до завершення', щоб активувати етап закриття",
    "LIST_VIEW" : "Список",
    "TERMINATE" : "Завершити",
    "MINIMIZE" : "Згорнути",
    "MAXIMIZE" : "Розгорнути",
    "NO_SEARCH_RESULT" : "Результати не знайдено",
    "SENTIMENT_AWAITING" : "Очікування настрію",
    "POSITIVE" : "Позитивний",
    "NEGATIVE" : "Негативний",
    "ASSOCIATED_WORK_NOTES": "Попередні нотатки про вирішення",
    "AGENT_JOINED_CONV": "Агент приєднався до розмови",
    "AUTOSCROLL_ASSIST" : "Автопрокрутка вмісту вкладки Assist",
    "FILE_SIZE_MSG" : "Розмір файлу має бути до 25 МБ. Повторіть спробу.",
    "OVERRIDE_BTN" : "Перевизначення",
    "CHOOSE_FILE" : "Виберіть файл",
    "SUMMARY_ERROR_TEXT" : "Вибачте, сталася проблема при створенні резюме для цієї розмови. Будь ласка, створіть власне резюме",
    "ASK_A_QUESTION": "Задайте питання",
    "COPY" : "Копіювати",
    "TELL_US_MORE": "Розкажіть нам більше…",
    "THANKS_FEEDBACK": "Дякуємо за ваш відгук",
    "SOMETHING_WRONG": "Щось пішло не так",
    "CLICK_ERROR_DETAILS": "Натисніть, щоб переглянути деталі помилки",
    "NO_ACTIVE_PLAYBOOK": "Немає активної книги сценаріїв",
    "REPHRASE_QUESTION": "Чи можете ви переформулювати своє питання або задати щось інше?",
    "VIEW_FULL_ARTICLE_2": "Переглянути повну статтю",
    "VIEW_FULL_FILE_2": "Переглянути повний файл",
    "INTERNAL_INFO": "Внутрішня інформація",
    "SOURCES": "Джерела",
    "CONVERSATION_SUMMARY": "Резюме розмови",
    "WAITING": "Чекаю",
    "WIDGET_DISABLED": "Віджет вимкнено",
    "AI_SETTINGS_DISABLED": "Налаштування ШІ вимкнено! Будь ласка, зверніться до адміністратора ШІ",
    "SERVER_CONNECTION_ERROR": "Помилка під час підключення до сервера",
    "VIEW": "Перегляд",
    "PLAYBOOK": "Плейбук",
    "ATTACHMENT_INPUT": "Введення вкладення",
    "TYPE_SUMMARY": "Наберіть резюме",
    "BY":"Ким",
    GENERATE_SUMMARY: "Створити резюме",
    PREV_SUMMARIES: "Раніше створені резюме",
    DIALOG_WORKFLOWS: "Робочі процеси діалогів",
    SHOW_ALL_DIALOG: "Показати всі завдання діалогу",
    SHOW_ALL_DIALOGS: "Показати всі діалоги",
    CUSTOM_TAB: "Користувацька вкладка",
    AGENT_INPUT: "Введення агента",
    CUSTOM_EMPTY_MSG: "Наразі немає активного робочого процесу",
    CUSTOM_TAB_DESC: "Щоб розпочати робочий процес, виконайте один з елементів із списку, розташованого внизу екрану.",
    SUBMIT_OVERALL_FEEDBACK: "Надіслати загальний відгук",
    FEEDBACK_POPUP_SUBTITLE: "Відгук про віджет та його функції",
    FEEDBACK_SATISFIED: "Задоволений",
    FEEDBACK_UNSATISFIED: "Незадоволений",
    FEEDBACK_PROVIDE_REASONS: "Надати більше інформації...",
    FEEDBACK_TITLE: "Відгук",
    "AGENTIC_THINKING" : "Думає",
    "AGENTIC_AGENT_TITLE" : "Агент",
    "AGENTIC_COPILOT_MODE_TITLE" : "Режим Агентного Копілота",
    "AGENTIC_SENDING_MESSAGE" : "Відправка...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot активно слухає вашу розмову та готовий автоматично допомогти",
    "AGENTIC_SEARCH_RESULTS" : "Агентні результати"
}